import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import * as color from '../../config/colors';
import * as background from '../../config/backgroundColor';
import * as legend from '../../config/legend';
import * as series from '../../config/series';
import * as toolbox from '../../config/toolbox';
import * as tooltip from '../../config/tootip';
import * as xAxis from '../../config/xAxis';
import * as yAxis from '../../config/yAxis';
import * as brush from '../../config/brush';
import * as datazoom from '../../config/datazoom';
import * as grid from '../../config/grid';
import { CommonService } from '../../service/common.service';
import { EChartOption } from 'echarts';
import { ChartOptionService } from '../../service/chart-option.service';
import { ECharts } from 'echarts';


@Injectable({
  providedIn: 'root'
})
export class BasicScatterService {

  constructor(
    private commonService: CommonService,
    private chartOptionService: ChartOptionService
  ) { }

  getChartxAxis() {
    let xAxisOption: EChartOption.XAxis[] = this.chartOptionService.getChartxAxis(1);
    xAxisOption.forEach(e => {
      e['boundaryGap'] = true;
    });
    return xAxisOption;
  }

  setInterval(option: any, interval: Number) {
    option.xAxis[0].axisLabel.interval = interval;
  }

  topLegendChange(legendData: any[], optionInit: ECharts) {
    legendData.forEach(e => {
      if (e.checked) {
        optionInit.dispatchAction({
          type: "legendSelect",
          name: e.value
        });
      } else {
        optionInit.dispatchAction({
          type: "legendUnSelect",
          name: e.value
        })
      }
    })
  }

  // 设置smallMode
  setSmallModeGrid(gridOption: EChartOption.Grid) {
    gridOption.top = grid.baseSmallPadding;
    gridOption.bottom = grid.baseSmallPadding;
    gridOption.left = grid.baseSmallPadding;
    gridOption.right = grid.baseSmallPadding;
  }
  setSmallModePadding(component) {
    component.cardPadding = "0rem";
  }

  // 设置x轴名
  setXaxisName(xAxisOption: EChartOption.XAxis[], xAxisName: string) {
    xAxisOption.forEach(e => {
      e.name = xAxisName;
    })
  }
  // 设置y轴名
  setYaxisName(yAxisOption: EChartOption.YAxis[], yAxisName: string) {
    yAxisOption.forEach(e => {
      e.name = yAxisName;
    })
  }
  // 设置y轴名距离
  setYNameGap(yAxisOption: EChartOption.YAxis[], yNameGap: number) {
    yAxisOption.forEach(e => {
      e.nameGap = yNameGap;
    })
  }

  // 设置x轴label旋转
  setXAxisLabelRotate(xAxisOption: EChartOption.XAxis[], xAxisLabelRotate) {
    let rotate = 0;
    switch (xAxisLabelRotate) {
      case 'leftSmallAngle':
        rotate = 30
        break;
      case 'leftBigAngle':
        rotate = 60
        break;
      case 'rightSmallAngle':
        rotate = -30
        break;
      case 'rightBigAngle':
        rotate = -60
        break
    }
    xAxisOption.forEach(element => {
      element.axisLabel.rotate = rotate;
      element.axisLabel.formatter = (value: string) => {
        let valueText = '';
        if (value.length > 5) {
          valueText = value.substring(0, 5) + '...'
        } else {
          valueText = value;
        }
        return valueText;
      }
    })
  }

  changeChartTitleDark(component, darkMode: boolean) {
    if (darkMode) {
      component.chartTitleColor = color.darkModeTextColor;
      component.cardBgColor = background.darkModeBGColor;
    }
  }

  setLegendPosition(gridOption: EChartOption.Grid, legendOption, legendPosition: string) {
    let style = this.commonService.changeFontSize();
    switch (legendPosition) {
      case "top":
        legendOption.show = false;
        break;
      case "right":
        gridOption['top'] = style.rightLegendGrid.top;
        gridOption['right'] = style.rightLegendGrid.right;
        gridOption['left'] = style.rightLegendGrid.left;
        gridOption['bottom'] = style.rightLegendGrid.bottom;

        legendOption['top'] = '14%';
        legendOption['right'] = 0;
        legendOption['bottom'] = gridOption.bottom;
        legendOption['width'] = gridOption.right;
        legendOption['orient'] = "vertical";
        legendOption['pageIcons'] = {
          vertival: [
            "path://M472.064 272.448l-399.232 399.232c-22.08 22.08-22.08 57.792 0 79.872 22.016 22.016 57.792 22.08 79.872 0L512 392.256l359.296 359.296c22.016 22.016 57.792 22.08 79.872 0 22.08-22.08 22.016-57.792 0-79.872L551.936 272.448C529.856 250.432 494.144 250.432 472.064 272.448z",
            "path://M472.064 751.552 72.832 352.32c-22.08-22.08-22.08-57.792 0-79.872 22.016-22.016 57.792-22.08 79.872 0L512 631.744l359.296-359.296c22.016-22.016 57.792-22.08 79.872 0 22.08 22.08 22.016 57.792 0 79.872l-399.232 399.232C529.856 773.568 494.144 773.568 472.064 751.552z"
          ],
        };
        legendOption['textStyle']['padding'] = [2, 0, 0, 0];
        break;
      case "none":
        legendOption.show = false;
        break;
      default:
        gridOption.bottom = legend.bottomLegendHeight;
        break;
    }
  }
  // 背景色的darkMode
  chartBackgroundColorDarkMode(chartOption) {
    chartOption.backgroundColor = background.darkModeBGColor;
  }
  // 设置x轴的darkMode
  xAxisDarkMode(xAxisOption: EChartOption.XAxis[]) {
    xAxisOption.forEach(e => {
      if (_.isNil(e['axisLabel'])) {
        e['axisLabel'] = {};
      }
      e['axisLabel']['color'] = color.darkModeTextColor;
      if (_.isNil(e['nameTextStyle'])) {
        e['nameTextStyle'] = {};
      }
      e['nameTextStyle']['color'] = color.darkModeTextColor;
    });
  }
  // 设置y轴darkMode
  yAxisDarkMode(yAxisOption: EChartOption.YAxis[]) {
    yAxisOption.forEach(e => {
      if (_.isNil(e['axisLabel'])) {
        e['axisLabel'] = {};
      }
      e['axisLabel']['color'] = color.darkModeTextColor;
      if (_.isNil(e['nameTextStyle'])) {
        e['nameTextStyle'] = {};
      }
      e['nameTextStyle']['color'] = color.darkModeTextColor;
      if (_.isNil(e['splitLine'])) {
        e['splitLine'] = {
          lineStyle: {
            color: color.darkModeTextColor
          }
        };
      } else {
        if (_.isNil(e['splitLine']['lineStyle'])) {
          e['splitLine']['lineStyle'] = {
            color: color.darkModeTextColor
          }
        } else {
          e['splitLine']['lineStyle']['color'] = color.darkModeTextColor;
        }
      }
    });
  }
  // 文字颜色DarkMode
  colorsDarkMode(chartColor: string[]) {
    chartColor.length = 0;
    color.darkModeColors.forEach(e => chartColor.push(e))
  }

  chartColorsChange(colors: string[], colorList: string[]) {
    colors.length = 0;
    colorList.forEach(e => {
      colors.push(e);
    })
  }

  // 图例的darkMode
  legendDarkMode(legendOption) {
    if (_.isNil(legendOption['textStyle'])) {
      legendOption['textStyle'] = {
        color: color.darkModeTextColor
      };
    } else {
      legendOption['textStyle']['color'] = color.darkModeTextColor;
    }
  }
  // 系列的darkMode
  seriesDarkMode(seriesOption: EChartOption.Series) {
    if (_.isNil(seriesOption['label'])) {
      seriesOption['label'] = {};
    }
    seriesOption['label']['color'] = color.darkModeTextColor;
  }

  setYAxisMin(yAxisOption: EChartOption.YAxis[], yAxisMin: number) {
    yAxisOption.forEach(e => {
      e.min = yAxisMin;
    })
  }

  setYAxisMax(yAxisOption: EChartOption.YAxis[], yAxisMax: number) {
    yAxisOption.forEach(e => {
      e.max = yAxisMax;
    })
  }

  setYAxisInterval(yAxisOption: EChartOption.YAxis[], yAxisInterval: number) {
    yAxisOption.forEach(e => {
      e.interval = yAxisInterval;
    })
  }

  setDimensions(dimensions, scatterSeries: EChartOption.SeriesScatter) {
    if (dimensions && Array.isArray(dimensions)) {
      scatterSeries.dimensions = dimensions;
    }
  }

  getDefaultScatterSeries() {
    let seriesOption: EChartOption.SeriesScatter = this.chartOptionService.getDefaultScatterSeries();
    return seriesOption;
  }

  getDefaultScatterTooltip() {
    let tooltipOption = this.chartOptionService.getScatterTooltip();
    return tooltipOption;
  }

  buildSeries(chartData: any, seriesList: EChartOption.Series[], scatterSeriesOpt: EChartOption.Series) {
    seriesList.length = 0;

    if (chartData && chartData.hasOwnProperty('seriesName')) {
      for (let i = 0; i < chartData.seriesName.length; i++) {
        let scatterSeries: EChartOption.Series = _.cloneDeep(scatterSeriesOpt)
        if (!_.isNil(chartData.seriesName[i]) && chartData.hasOwnProperty('data')) {
          scatterSeries['name'] = chartData.seriesName[i];
          scatterSeries['data'] = chartData.data[i];
        }
        seriesList.push(scatterSeries);
      }
    }
  }


  // 设置tooltip单位
  setTooltipUnit(tooltipOption: EChartOption.Tooltip, unit: string[]) {
    tooltipOption.formatter = tooltip.getTooltipOfScatter(unit).formatter;
  }

  // 设置轴分隔线的开关
  setSplitLineShow(xAxisOption: EChartOption.XAxis[], yAxisOption: EChartOption.YAxis[], splitLineShow: boolean | boolean[]) {
    if (Array.isArray(splitLineShow)) {
      if (!_.isNil(splitLineShow[0]) && splitLineShow[0] == true) {
        xAxisOption.forEach(e => {
          e.splitLine.show = true;
        })
      } else {
        xAxisOption.forEach(e => {
          e.splitLine.show = false;
        })
      }

      if (!_.isNil(splitLineShow[1]) && splitLineShow[1] == true) {
        yAxisOption.forEach(e => {
          e.splitLine.show = true
        })
      } else {
        yAxisOption.forEach(e => {
          e.splitLine.show = false;
        })
      }

    } else {
      if (splitLineShow == true) {
        xAxisOption.forEach(e => {
          e.splitLine.show = true;
        })
        yAxisOption.forEach(e => {
          e.splitLine.show = true;
        })
      } else {
        xAxisOption.forEach(e => {
          e.splitLine.show = false;
        })
        yAxisOption.forEach(e => {
          e.splitLine.show = false;
        })
      }
    }
  }

  // 设置散点的大小
  setSymbolSize(size, scatterSeriesOpt: EChartOption.SeriesScatter) {
    scatterSeriesOpt.symbolSize = size;
  }
}
